import { Box, Divider, Typography } from "@mui/material";

import type { SKUStoreResourceCardSlotProps } from "@/features/SKUStore/components/ResourceCard/SKUStoreResourceCard.types";

export function SKUStoreResourceCardAccentPill({
  children,
}: SKUStoreResourceCardSlotProps) {
  return (
    <Box
      sx={{
        alignSelf: "flex-start",
        bgcolor: "success.main",
        borderRadius: (theme) => theme.shape.borderRadiusLg,
        px: 4,
        py: 2,
      }}
    >
      <Typography
        variant="body3"
        sx={{
          color: "success.contrastText",
          fontWeight: (t) => t.typography.fontWeightScale.semiBold,
        }}
      >
        {children}
      </Typography>
    </Box>
  );
}

export function SKUStoreResourceCardDetailRow({
  children,
}: SKUStoreResourceCardSlotProps) {
  return (
    <>
      <Divider
        sx={(theme) => ({
          borderColor: theme.palette.tokens.outlines.defaultDividerLight,
        })}
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          minHeight: 28,
        }}
      >
        <Typography
          component="div"
          variant="body2"
          sx={{ color: "text.secondary" }}
        >
          {children}
        </Typography>
      </Box>
    </>
  );
}
